/**
 * Environment-aware logging utility for frontend (Vite/React)
 * Logs only in development environment to reduce production noise
 */

/**
 * Logger class that conditionally logs based on Vite environment
 */
class Logger {
  private isDev: boolean;

  constructor() {
    // Vite provides built-in environment detection
    this.isDev = import.meta.env.DEV;
  }

  private shouldLog(): boolean {
    return this.isDev;
  }

  log(...args: unknown[]): void {
    if (this.shouldLog()) {
      console.log(...args);
    }
  }

  error(...args: unknown[]): void {
    if (this.shouldLog()) {
      console.error(...args);
    }
  }

  warn(...args: unknown[]): void {
    if (this.shouldLog()) {
      console.warn(...args);
    }
  }

  info(...args: unknown[]): void {
    if (this.shouldLog()) {
      console.info(...args);
    }
  }

  debug(...args: unknown[]): void {
    if (this.shouldLog()) {
      if (typeof console.debug !== 'undefined') {
        console.debug(...args);
      } else {
        console.log(...args);
      }
    }
  }
}

/**
 * Singleton logger instance for the entire application
 */
export const logger = new Logger();

// Re-export individual console methods for convenience
export const { log, error, warn, info, debug } = logger;
